// TODO: Abstract the use of these images to use vector-image service
import iconImage from './assets/Depth chart.png';

const { host } = window.location;
let domain = host;
if (host !== 'deckee.com') domain = 'staging.deckee.com';

/** This file is still called `nautical` instead of `chart` to avoid having to do a DB migration. */
export default {
  displayName: 'Coastal depths',
  iconImage,
  subscriberOnly: true,
  iconBackgroundColor: '#ADE1FE',
  style: `https://${domain}/public/map-tile-server/map-styles/nautical.json`,
};
